import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import {
  simpleQueryFirestoreWithFilter,
  simpleQueryFirestoreWithFilterOrderBy,
  joinCollections,
  firestoreCollectionToArray,
  addPropertyToCollection,
  firestoreCollectionToContainsArray,
  createCleanServiceRows,
  sortJoinCollectionsData,
  chunkFilter,
} from '../../components/utility/firestore.helper';
import { rsf, db } from '@iso/lib/firebase/firebase';
import { call } from 'redux-saga/effects';
import omit from 'lodash/omit';
import { convertCollectionsSnapshotToArray } from '@iso/lib/firebase/firebase.util';
import { getValidNextReservationNumber, getTimezonesArray } from './saga-helper';
import DateFormatter from "../../components/utility/DateFormatter";
import { getAccountIdPrefix } from '@iso/components/library/helpers/local_storage';

const COLLECTION_NAME_BOOKING = 'bookings';
const COLLECTION_NAME_PROPERTIES = 'properties';

function* loadBooking(query) {
  try {
    const filterBooking = { 'booking': { 'value': query.payload.id, 'operator': '==', 'field': 'id' } };
    const data = yield simpleQueryFirestoreWithFilter(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, filterBooking);
    const dataSource = [];
    Object.keys(data).map((item, index) => {
      return dataSource.push({
        ...data[item],
        key: item,
      });
    });
    yield put(actions.loadBookingSuccess(dataSource[0]));
  }
  catch (error) {
    yield put(actions.loadBookingError(error));
  }
}

function* loadBookings(query) {
  try {
    const filtersBooking = query && query.payload.filterBooking;
    const data = yield firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, filtersBooking);
    yield put(actions.loadBookingsSuccess(data));


  }
  catch (error) {
    yield put(actions.loadBookingsError(error));
  }
}

function* getNextReservationNumber() {
  try {
    let collectionRef = db.collection(getAccountIdPrefix() + COLLECTION_NAME_BOOKING).orderBy('reservation_number', 'desc').limit(1)
    const snapshots = yield call(rsf.firestore.getCollection, collectionRef);
    const data = yield call(convertCollectionsSnapshotToArray, snapshots);
    const nextReservationNumber = getValidNextReservationNumber(data);
    return nextReservationNumber
  }
  catch (error) {
    yield put(actions.getNextReservationNumberError(error));
  }
}

function* loadBookingsWithProperties(query) {

  try {
    let filtersBooking = query && query.payload.filterBooking;
    let filterBookingQuery = [];
    if (!filtersBooking) filtersBooking = {};
    if (filtersBooking.start_date) {
      filterBookingQuery.push(
        {
          field: "start_date",
          operator: ">=",
          value: filtersBooking.start_date.value,
        })
    }
    else {
      let d = new Date();
      filterBookingQuery.push(
        {
          field: "start_date",
          operator: ">=",
          value: DateFormatter.getValueOfDate(d.setMonth(d.getMonth() - 6)),
        });
    }

    if (filtersBooking.property) {
      filterBookingQuery.push(
        {
          field: "property_id",
          operator: "==",
          value: filtersBooking.property.value,
        });
    }

    if (filtersBooking.name) {
      filterBookingQuery.push(
        {
          field: "name",
          operator: "==",
          value: filtersBooking.name.value,
        });
    }

    if (filtersBooking.surname) {
      filterBookingQuery.push(
        {
          field: "surname",
          operator: "==",
          value: filtersBooking.surname.value,
        });
    }

    if (filtersBooking.end_date) {
      filterBookingQuery.push(
        {
          field: "start_date",
          operator: "<=",
          value: filtersBooking.end_date.value,
        });
    }

    if (filtersBooking.status) {
      filterBookingQuery.push(
        {
          field: "status",
          operator: filtersBooking.status.operator,
          value: filtersBooking.status.value,
        });
    }
    const filtersProperty = query && query.payload.filterProperty;
    const orderBy = { type: 'desc', field: 'start_date' };
    let bookingData = yield simpleQueryFirestoreWithFilterOrderBy(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, filterBookingQuery, orderBy);
    let propertyData = yield simpleQueryFirestoreWithFilter(getAccountIdPrefix() + COLLECTION_NAME_PROPERTIES, filtersProperty);
    const data = yield joinCollections(bookingData, propertyData, 'property_id', 'property');
    yield put(actions.loadBookingsWithPropertiesSuccess(data));
  }
  catch (error) {
    console.log(error);
    yield put(actions.loadBookingsWithPropertiesError(error));
  }
}


function* loadArrivalDepartureWithProperties(query) {
  try {
    const filtersBooking = query && query.payload.filterBooking;
    const filtersProperty = query && query.payload.filterProperty;
    
    // Validar que existan los filtros necesarios
    if (!filtersBooking) {
      yield put(actions.loadArrivalDepartureWithPropertiesError(new Error('Filtros de booking requeridos')));
      return;
    }

    // Construir filtros base comunes
    const baseFilters = filtersBooking.status ? { status: filtersBooking.status } : {};
    
    // Construir filtros específicos para cada tipo de consulta
    const arrivalFilters = {
      ...baseFilters,
      ...(filtersBooking.start_date_arrival && { start_date: filtersBooking.start_date_arrival }),
      ...(filtersBooking.end_date_arrival && { end_date: filtersBooking.end_date_arrival })
    };
    
    const departureFilters = {
      ...baseFilters,
      ...(filtersBooking.start_date_departure && { start_date: filtersBooking.start_date_departure }),
      ...(filtersBooking.end_date_departure && { end_date: filtersBooking.end_date_departure })
    };

    // Ejecutar consultas en paralelo para mejor rendimiento
    const [bookingDataArrival, bookingDataDeparture, propertyData] = yield all([
      firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, arrivalFilters),
      firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, departureFilters),
      firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_PROPERTIES, filtersProperty)
    ]);

    // Procesar datos de limpieza si existen
    let bookingDataClean = [];
    if (filtersBooking.clean_services && Array.isArray(filtersBooking.clean_services) && filtersBooking.clean_services.length > 0) {
      bookingDataClean = yield processCleanServicesData(filtersBooking.clean_services);
    }

    // Procesar y combinar todos los datos
    const processedData = processBookingData({
      arrival: bookingDataArrival,
      departure: bookingDataDeparture,
      clean: bookingDataClean,
      cleanServices: filtersBooking.clean_services
    });

    // Unir con datos de propiedades
    const data = yield joinCollections(processedData, propertyData, 'property_id', 'property');

    yield put(actions.loadArrivalDepartureWithPropertiesSuccess(data));
  }
  catch (error) {
    console.error('Error en loadArrivalDepartureWithProperties:', error);
    yield put(actions.loadArrivalDepartureWithPropertiesError(error));
  }
}

// Función helper para procesar datos de servicios de limpieza
function* processCleanServicesData(cleanServices) {
  try {
    const cleanServicesChunks = chunkFilter(cleanServices, 10);
    const allCleanData = [];
    
    // Procesar chunks en paralelo para mejor rendimiento
    const chunkPromises = cleanServicesChunks.map(chunk => 
      processCleanServicesChunk(chunk)
    );
    
    const chunkResults = yield all(chunkPromises);
    return chunkResults.flat();
  } catch (error) {
    console.error('Error procesando servicios de limpieza:', error);
    return [];
  }
}

// Función helper para procesar un chunk de servicios de limpieza
function* processCleanServicesChunk(cleanServicesChunk) {
  try {
    const timezoneArray = getTimezonesArray(cleanServicesChunk);
    const timezoneChunks = chunkFilter(timezoneArray, 10);
    
    // Procesar chunks de timezone en paralelo
    const timezonePromises = timezoneChunks.map(timezoneChunk =>
      firestoreCollectionToContainsArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, timezoneChunk)
    );
    
    const timezoneResults = yield all(timezonePromises);
    return timezoneResults.flat();
  } catch (error) {
    console.error('Error procesando chunk de servicios de limpieza:', error);
    return [];
  }
}

// Función helper para procesar y combinar datos de booking
function processBookingData({ arrival, departure, clean, cleanServices }) {
  // Agregar propiedades de tipo a cada conjunto de datos
  const processedArrival = addPropertyToCollection(arrival, 'arrival');
  const processedDeparture = addPropertyToCollection(departure, 'departure');
  
  // Procesar datos de limpieza si existen
  let processedClean = [];
  if (clean && clean.length > 0 && cleanServices) {
    processedClean = createCleanServiceRows(clean, cleanServices);
    processedClean = addPropertyToCollection(processedClean, 'clean');
  }

  // Combinar todos los datos
  const allBookingData = [...processedArrival, ...processedDeparture, ...processedClean];
  
  // Ordenar datos combinados
  return sortJoinCollectionsData(allBookingData);
}

function* deleteBooking({ payload }) {
  const { data, filterBooking } = payload;
  try {
    yield call(rsf.firestore.deleteDocument, getAccountIdPrefix() + COLLECTION_NAME_BOOKING + '/' + data.key)
    yield put(actions.deleteBookingSuccess());
    yield put({ type: actions.LOAD_BOOKINGS_WITH_PROPERTIES, payload: { filterBooking: filterBooking } });
    yield put(actions.cleanNotificationMessage());
  } catch (error) {
    yield put(actions.deletePropertyError(error));
  }
}

function* saveBooking({ payload }) {
  const { data, actionName } = payload;
  try {
    switch (actionName) {
      case 'update':
        yield call(rsf.firestore.setDocument, `${getAccountIdPrefix() + COLLECTION_NAME_BOOKING}/${data.key}`, {
          ...omit(data, ['key']),
        });
        yield put(actions.updateBookingSuccess());
        break;
      default:
        let reservationNumber = yield getNextReservationNumber()
        data.reservation_number = reservationNumber
        yield call(rsf.firestore.addDocument, getAccountIdPrefix() + COLLECTION_NAME_BOOKING, {
          ...omit(data, ['user', 'key']),
        });
        yield put(actions.saveBookingSuccess());
        break;
    }
  } catch (error) {
    console.log(error);
    yield put(actions.storeBookingError(error));
  }
}

function* updateStatusBooking({ payload }) {
  const { data } = payload;
  try {
    yield call(rsf.firestore.updateDocument, `${getAccountIdPrefix() + COLLECTION_NAME_BOOKING}/${data.key}`, { status: data.status });
    yield put(actions.updateStatusBookingSuccess());
    yield put(actions.cleanNotificationMessage());
  }
  catch (error) {
    yield put(actions.updateStatusBookingError(error));
    yield put(actions.cleanNotificationMessage());
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_BOOKING, loadBooking),
    takeEvery(actions.LOAD_BOOKINGS, loadBookings),
    takeEvery(actions.LOAD_BOOKINGS_WITH_PROPERTIES, loadBookingsWithProperties),
    takeEvery(actions.LOAD_ARRIVAL_DEPARTURE_WITH_PROPERTIES, loadArrivalDepartureWithProperties),
    takeEvery(actions.SAVE_BOOKING, saveBooking),
    takeEvery(actions.UPDATE_BOOKING, saveBooking),
    takeEvery(actions.UPDATE_STATUS_BOOKING, updateStatusBooking),
    takeEvery(actions.DELETE_BOOKING, deleteBooking),
    takeEvery(actions.GET_NEXT_RESERVATION_NUMBER, getNextReservationNumber),
  ]);
}
